import { render, staticRenderFns } from "./AppSkills.vue?vue&type=template&id=3c0bacd8&scoped=true&"
import script from "./AppSkills.vue?vue&type=script&lang=js&"
export * from "./AppSkills.vue?vue&type=script&lang=js&"
import style0 from "./AppSkills.vue?vue&type=style&index=0&id=3c0bacd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bacd8",
  null
  
)

export default component.exports